import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { SessionStore, TaxRegistrationStore } from '../stores'
import { LoginLayout } from '../components/login-layout'
import { loadTaxRegistrationsData } from '../contents/configuration/tax-registrations'
import { syncObligationsData } from '../contents/submission-gateway/obligations/sync'
import { withTenant } from '../utils/with-tenant'
import { handleErrorsLogin } from '../components/handle-errors'
const marginTop = {
  'margint=Top': '10px'
}

@inject('taxRegistrationStore', 'sessionStore')
@observer
class LoginPage extends Component {
  constructor (props) {
    super(props)
    this.username = React.createRef()
    this.password = React.createRef()
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      ready: false
    }
    this.saveBtnRef = React.createRef()
    this.loginFormRef = React.createRef()
  }

  componentDidMount () {
    if (this.props.sessionStore.isLoggedIn) {
      window.location.replace('/')
    } else {
      this.setState({ ready: true }, () => this.setup())
    }
  }

  setup () {
    this.loginFormRef.current.addEventListener('submit', (e) => this.handleSubmit(e))
    if (this.props.sessionStore.tenant) {
      const lastUnderscore = this.props.sessionStore.tenant.substring(this.props.sessionStore.tenant.length, this.props.sessionStore.tenant.length - 1)
      const firstUnderscore = this.props.sessionStore.tenant.substring(0, 1)
      if (this.loginFormRef.current && !['_', '-'].includes(lastUnderscore) && !['_', '-'].includes(firstUnderscore)) {
        this.loginFormRef.current.setAttribute('captcha', '')
        this.loginFormRef.current.setAttribute('site-key', this.props.env.CAPTCHA_SITE_KEY)
      }
    }
  }

  handleCatchErrors = (error) => {
    handleErrorsLogin(error, this.props.sessionStore)
    this.saveBtnRef.current.disabled = false
    this.saveBtnRef.current.hideSpinner()
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.sessionStore.setLastError(null)
    this.props.sessionStore.isLoading = true
    // disable the submit button
    this.saveBtnRef.current.disabled = true
    this.saveBtnRef.current.showSpinner()
    if (this.props.sessionStore.sysAdmin) {
      this.props.sessionStore.login(this.username.current.value, this.password.current.value, this.props.env).then(() => {
        this.props.sessionStore.isLoading = false
        this.saveBtnRef.current.hideSpinner()
        window.location.replace('/admin')
      }).catch(error => {
        this.handleCatchErrors(error)
      })
    } else {
      this.props.sessionStore.login(this.username.current.value, this.password.current.value, this.props.env)
        .then(() => loadTaxRegistrationsData(this.props.sessionStore, this.props.taxRegistrationStore))
        .then(() => syncObligationsData(this.props.sessionStore, this.props.taxRegistrationStore))
        .then((syncObligationsSuccess) => {
          this.props.sessionStore.isLoading = false
          if (this.props.taxRegistrationStore.taxRegistrationList.length > 0 && syncObligationsSuccess) {
            window.location.replace('/')
          } else if (this.props.taxRegistrationStore.taxRegistrationList.length > 0) {
            window.location.replace('/submission-gateway/authorisation?status=failed')
          } else {
            window.location.replace('/getting-started')
          }
        })
        .catch(error => {
          this.handleCatchErrors(error)
        })
    }
  }

  render () {
    if (this.state.ready) {
      return (
        <LoginLayout title='Login' env={this.props.env}>
          <div className='content mb-4'>
            <h5 className='content-title text-center'>Enter your details to log in</h5>
            {
              this.props.sessionStore.lastError &&
              <mosaic-alert color='danger'>
                <p>{this.props.sessionStore.lastError.message}</p>
              </mosaic-alert>
            }
            <mosaic-form ref={this.loginFormRef}>
              <div className='form-group'>
                <mosaic-text-input
                  name='Input1'
                  block
                  label='Email'
                  ref={this.username}
                  required
                  placeholder='Enter your email address'
                >
                </mosaic-text-input>
              </div>
              <div className='form-group'>
                <mosaic-password-input
                  name='myInput'
                  block
                  ref={this.password}
                  label='Password'
                  required
                  placeholder='Enter your password'
                >
                </mosaic-password-input>
              </div>
              <mosaic-form-actions>
                <mosaic-button
                  block
                  ref={this.saveBtnRef}
                  color='primary'
                  style={marginTop}
                  submit
                  spinner
                >Log In
                </mosaic-button>
              </mosaic-form-actions>
              <div className='form-group'>
                <a href='/forgot-password'>Forgotten password</a>
              </div>
            </mosaic-form>
          </div>
        </LoginLayout>
      )
    } else {
      return <div>&nbsp;</div>
    }
  }
}

LoginPage.propTypes = {
  taxRegistrationStore: PropTypes.instanceOf(TaxRegistrationStore),
  sessionStore: PropTypes.instanceOf(SessionStore),
  env: PropTypes.object
}

export default withTenant(LoginPage)
